// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1W8CL","item":"PaymentsMobile_item__1tQkT","label":"PaymentsMobile_label__2dX4B","amount":"PaymentsMobile_amount__1nGiP"};